import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../app/hooks";
import { NameIdOption } from "../common/types/commonTypes";
import { Tes, tesAutocompleteQuery } from "../features/customer/customerAPI";

const useTesAutocompleteQuery = () => {
  const { i18n } = useTranslation();
  const language = i18n.language.substring(0, 2);
  const [tesSearchTerm, setTesSearchTerm] = useState<string>("");
  const [tesQueryResult, setTesQueryResult] = useState<Tes[]>([]);
  const [tesOptions, setTesOptions] = useState<NameIdOption[]>([]);

  const { tes: tesNames } = useAppSelector((state) => state.localized);

  useEffect(() => {
    if (!tesSearchTerm) return;
    tesAutocompleteQuery({ term: tesSearchTerm, languageCode: language }).then(
      (result) => {
        setTesQueryResult(result);
        setTesOptions(
          result.map((tes) => ({
            id: tes.id,
            name: tesNames[tes.id] || tes.id,
          })),
        );
      },
    );
    // FIXME: fix this or add comment why this is needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tesSearchTerm, language]);

  return {
    setTesSearchTerm,
    tesQueryResult,
    tesIdsQueryResult: tesQueryResult.map((tes) => tes.id),
    tesOptions,
  };
};

export default useTesAutocompleteQuery;
